<template>
  <div id="popup-component" class="popup__main">
    <div class="popup__header">
      <a href="#" class="popup__close" @click.prevent="closePopup"></a>
    </div>
    <div class="popup__content">
      <div class="popup__title">
        <p>menu</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { useMainStore } from '@/store/main';

export default {
  name: 'PopupComponent',
  data: () => {
    return {};
  },
  computed: {
    ...mapState(useMainStore, ['popup']),
  },
  methods: {
    ...mapActions(useMainStore, ['closePopup']),
  },
  mounted() {},
  components: {},
};
</script>

<style lang="scss"></style>
